import { Charge } from "@/pages/sy/models/Charge";
import { useUpsertChargeMutation } from "@/pages/sy/hooks/queries/useChargeMutations";

type UseBucketHandlersProps = {
  currentOperatorId: number | null;
  currentChargeSequenceNumber: number | null;
  charge: Charge | null;
  setIsBucketDialogOpen: (isBucketDialogOpen: boolean) => void;
  refreshData: (options: { buckets?: boolean }) => void | Promise<void>;
  setError: (error: string) => void;
  setNotificationMessage: (message: string) => void;
};

export const useBucketHandlers = ({
  currentOperatorId,
  currentChargeSequenceNumber,
  charge,
  setIsBucketDialogOpen,
  refreshData,
  setError,
  setNotificationMessage,
}: UseBucketHandlersProps) => {
  const upsertChargeMutation = useUpsertChargeMutation();

  const handleBucketSelect = (bucketId: number) => {
    if (!charge?.ChargeId) return;

    setIsBucketDialogOpen(false);

    const chargeToUpdate: Charge = {
      ...charge,
      BucketId: bucketId,
      OperatorId: currentOperatorId,
      ChargeSequenceNumber:
        currentChargeSequenceNumber || charge.ChargeSequenceNumber || 1,
    };

    upsertChargeMutation.mutate(chargeToUpdate, {
      onSuccess: () => {
        setNotificationMessage("Bucket updated successfully");
      },
      onError: (error) => {
        setError(
          "Error updating bucket: " +
            (error instanceof Error ? error.message : String(error)),
        );
      },
    });
  };

  const handleOpenBucketDialog = () => {
    if (charge?.ChargeStatusCode === "C" || charge?.ChargeStatusCode === "H")
      return;
    refreshData({ buckets: true });
    setIsBucketDialogOpen(true);
  };

  const handleCloseBucketDialog = () => {
    setIsBucketDialogOpen(false);
  };

  return {
    handleBucketSelect,
    handleOpenBucketDialog,
    handleCloseBucketDialog,
    isBucketMutating: upsertChargeMutation.isPending,
  };
};
